import { AxiosError } from 'axios'

// import { AppDispatch } from '../../../App/store'
import { fetchNotifications, fetchReadNotification } from '../apiCalls'
import {
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_LOADING,
  GET_NOTIFICATIONS_FAILURE,
  READ_NOTIFICATION,
} from '../interface/actionTypes'
import { INotification } from '../interface/INotification'
import { transformNotifications } from '../transformNotifications'

const getNotificationsSuccess = (notifications: INotification[]) => {
  return {
    type: GET_NOTIFICATIONS_SUCCESS,
    payload: {
      list: notifications,
    },
  }
}

const getNotificationsFailure = (error: string) => {
  return {
    type: GET_NOTIFICATIONS_FAILURE,
    payload: { error },
  }
}

export const getNotifications = () => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_NOTIFICATIONS_LOADING })
    return fetchNotifications()
      .then(response => {
        const notifications = transformNotifications(response.data.list)
        dispatch(getNotificationsSuccess(notifications))
      })
      .catch((error: AxiosError) => {
        dispatch(getNotificationsFailure(error.message))
      })
  }
}

export const readNotification = (notificationId: string) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: READ_NOTIFICATION,
      payload: {
        id: notificationId,
      }
    })
    return fetchReadNotification(notificationId)
  }
}
